export const categories = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-global-line', description: '韩国人气漫画合集' },
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-2-line', description: '国产精品漫画' },
  { slug: 'shaonv', name: '少女', icon: 'ri-heart-line', description: '甜蜜浪漫少女漫' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '燃爆战斗热血漫' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '烧脑推理悬疑漫' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松欢乐搞笑漫' },
  { slug: 'danmei', name: '耽美', icon: 'ri-star-line', description: '唯美耽美漫画' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '异世界奇幻冒险' },
];